import {noop} from "lodash";
import {
    Add_Customer_Address,
    Cargo_Owner_Address_List,
    Cargo_Owner_Discount_List,
    Cargo_Owner_Info,
    Check_Customer_Id,
    Check_Product_Sku,
    Create_Customer,
    Customer_Information, Delete_Customer_Address,
    Download_Product_Template,
    Edit_Customer,
    Edit_Customer_Address,
    Filter_Owner,
    Import_Customer,
    Remove_Customer,
    Sku_Safe_Batch_Import
} from "../../config";
import api from "../../api/api";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import moment from "moment";
import {InventoryActionType} from "../inventory/inventoryAction";



export const addCustomer =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OwnerCustomerAdd)) return null;
        const url = `${Create_Customer}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess("CustomerPage.Customer created successfully")
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const editCustomer = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.OwnerCustomerModify)) return null;
        const url = `${Edit_Customer}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`${response.data.msg}`)
        } else {
            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const check_customer_id = (data,onSuccess = noop, onError = noop)  => async () => {
    try{

        // if (!checkPermission(PERMISSION_DICT.InventoryProductCheckUnique)) return null;
        const url = `${Check_Customer_Id}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(true)

        } else if((response?.status === 200 && response.data.code === 500)){
            onSuccess(false)
        }
        else {
            onError(response?.data?.msg)
        }
    } catch (e) {
        onError(e.message)
    }
}

export const editCustomerAddress = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.OwnerCustomerModifyAddress)) return null;
        const url = `${Edit_Customer_Address}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`Edit ${response.data.msg} Customer Address Successfully`)
        } else {
            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const addCustomerAddress = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.OwnerCustomerAddAddress)) return null;
        const url = `${Add_Customer_Address}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`Edit ${response.data.msg} Customer Address Successfully`)
        } else {
            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const deleteCustomerAddress = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.OwnerCustomerDeleteAddress)) return null;
        const url = `${Delete_Customer_Address}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`Edit ${response.data.msg} Customer Address Successfully`)
        } else {
            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const customerInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OwnerCustomerInfo)) return null;
        const url = `${Customer_Information}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const removeCustomer =(data,onSuccess = noop, onError = noop)  => async () => {

    try {
        const url = `${Remove_Customer}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.msg)
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}


export const downloadCargoDiscountTemplate = (onSuccess= noop, onError = noop) => async () =>{

    try{

        const xurl = `${Download_Product_Template}`
        const fileName = 'Owner_Discount_Setup_Template.xlsx'
        const response = await api.get(xurl,{params: { fileName: fileName },
            responseType: 'blob' })


        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Cargo_Discount_Template_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            console.error('Failed to download file. Server responded with status:', response.status);
            onError(`Failed to download file. Server responded with status:${response.status}`)
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const cargoOwnerDiscountList = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.CustomerCargoInfo)) return null;
        const url = `${Cargo_Owner_Discount_List}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response.data)
        } else {
            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const cargoOwnerAddressList = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.CustomerCargoInfo)) return null;
        const url = `${Cargo_Owner_Address_List}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const importCustomerList = (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OwnerCustomerBatchImport)) return null;
        const url = `${Import_Customer}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response?.data?.code === 200){

            onSuccess(response.data.data)
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }

}

export const downloadCustomerImportTemplate = (onSuccess= noop,onError = noop) => async () =>{

    try{
        const xurl = `${Download_Product_Template}`
        const customer = !checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        const fileName = customer ? 'Customer_address_Template.xlsx':'Customer_address_Template_admin.xlsx'
        const response = await api.get(xurl,{params: { fileName: fileName },
            responseType: 'blob' })
            .then(res=> res)

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Customer_Address_Template_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}